import axios from 'axios';

// 백엔드 Spring Boot URL
// 로컬 개발: localhost:8081/api
// 운영: 환경변수 REACT_APP_API_URL로 오버라이드
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8081/api';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 요청 인터셉터: JWT 토큰 자동 주입
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('copier_token');
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 응답 인터셉터: 401 시 자동 로그아웃
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // 로그인 API 자체에서 401이 나오면 그 페이지에서 처리
      const isLoginRequest = error.config?.url?.includes('/auth/login');
      if (!isLoginRequest) {
        localStorage.removeItem('copier_token');
        localStorage.removeItem('copier_refresh_token');
        localStorage.removeItem('copier_user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
